import { h, Component } from 'preact';
import ThreeSixtyStage from './threeSixtyStage/threeSixtyStage';
import Three from './three/three';
import Loadingbar from './loadingbar/loadingbar';
import ThumbBar from './thumbbar/thumbbar';
import config from '../config/config.json';

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: {
        imagesLoaded: 0,
        isLoaded: false,
        percentLoaded: 0
      },
      thumbbarHover: false,
      thumbbarOpen: false,
      zooming: 0
    };
    this.getVPwidth();

    this.setUrlParams();
  }

  componentDidMount() {
    window.addEventListener('orientationchange', this.getVPwidth);

    window.addEventListener('resize', this.getVPwidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.getVPwidth);
  }

  setUrlParams = () => {
    // all Carline and Request stuff are set to state
    const url = window.location.href;
    // remove index.html if in url
    const noIndex = url.replace('index.html', '');
    // regex to find the correct parameters to build imagePath
    const path_regex = new RegExp(
      /([A-Z]{2})\/([a-z]{2})\/([A-Z]{2})\/([A-Z|a-z]*)\/([a-z|A-Z|_]{5,10})/
    );
    const params = url.split(path_regex);
    // console.log('PARAMS', params)
    const country = params[1];
    const lang = params[2];
    const carline = params[4]
    const bodystyle = params[5];
    const imgPath =
      country +
      '/' +
      lang +
      '/' +
      params[3] +
      '/' +
      params[4] +
      '/' +
      bodystyle +
      '/';
    const absPath =
      process.env.NODE_ENV === 'production'
        ? noIndex
        : `${window.location.origin}/`;
    this.setState({
      imgPath,
      carline,
      country,
      lang,
      absPath
    });
    const marketConfig = config.array.find(
      market => market.market === `${country}_${lang}`
    );
    marketConfig &&
      marketConfig[carline] &&
      this.getConfig(marketConfig[carline]);
      if (this.isInteriorOnly) {
	      this.setState({
	      	showtext: marketConfig.text.menushowtext,
	      	hidetext: marketConfig.text.menuhidetext,
	      })
	    }
  };

  getConfig = marketConfig => {
    // find defaultThumb Index
    const defaultThumbIndex = marketConfig.findIndex(thumb => thumb.default);
    // set defaultThumb to state
    // get carline config from market
    this.setState({
      interior: {
        config: marketConfig,
        index: defaultThumbIndex
      }
    });
  };

  setActiveInterior = i => {
    this.setState({
      interior: {
        config: this.state.interior.config,
        index: i
      }
    });
  };

  getVPwidth = () => {
    this.setState({
      vw: Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      ),
      vh: Math.max(
        document.documentElement.clientHeight,
        window.innerHeight || 0
      )
    });
  };

  thumbbarHoverToggle = isOver => {
    this.setState({
      thumbbarHover: isOver
    });
  };

  // toggle Thumbbar
  thumbbarOpenToggle = () => {
    this.setState({
      thumbbarOpen: !this.state.thumbbarOpen
    });
  };

  loadHandling = amount => {
    const { loading } = this.state;
    this.setState({
      loading: {
        imagesLoaded: loading.imagesLoaded + 1,
        percentLoaded: (100 / amount) * (loading.imagesLoaded + 1),
        isLoaded: (100 / amount) * (loading.imagesLoaded + 1) === 100
      }
    });
  };

  resetLoad = () => {
    this.setState({
      loading: {
        imagesLoaded: 0,
        isLoaded: false
      }
    });
  };

  get isInteriorOnly() {
    const { carline } = this.state;
    return carline === 'camaro' || carline === 'spark';
  }

  handleZoomClicked = factor => {
    this.setState({ zooming: factor });
  };

  handleZoomStopped = () => {
    this.setState({ zooming: 0 });
  };

  render() {
    const {
      absPath,
      imgPath,
      interior,
      lang,
      loading,
      thumbbarHover,
      thumbbarOpen,
      vw
    } = this.state;

    // mobile stretching 12%

    const stretch = vw <= 500 ? 1.12 : 1;
    let input;
    if (this.isInteriorOnly) {
      input = (
        <div id="interior">
          <Three
            stageWidth={vw}
            stageHeight={(vw / 2) * stretch}
            loadHandling={this.loadHandling}
            imgPath={imgPath}
            interior={interior}
            absPath={absPath}
            thumbbarHover={thumbbarHover}
            thumbbarOpen={thumbbarOpen}
            zoomStopped={this.handleZoomStopped}
            zoomFactor={this.state.zooming}
            isInteriorOnly={this.isInteriorOnly}
            carline={this.state.carline}
          />
        {this.state.interior.config.length > 1 &&
          <ThumbBar
            absPath={absPath}
            imgPath={imgPath}
            interior={interior}
            thumbbarHoverToggle={this.thumbbarHoverToggle}
            thumbbarOpenToggle={this.thumbbarOpenToggle}
            thumbbarOpen={thumbbarOpen}
            vw={vw}
            setActiveInterior={this.setActiveInterior}
            resetLoad={this.resetLoad}
            zoomClicked={this.handleZoomClicked}
            hidetext={this.state.hidetext}
            showtext={this.state.showtext}
            isInteriorOnly={this.isInteriorOnly}
          />
        }
        </div>
      );
    } else {
      input = (
        <ThreeSixtyStage
          absPath={absPath}
          imgPath={imgPath}
          lang={lang}
          vw={vw}
          loadHandling={this.loadHandling}
          resetLoad={this.resetLoad}
          zoomClicked={this.handleZoomClicked}
          zoomStopped={this.handleZoomStopped}
          zoomFactor={this.state.zooming}
          carline={this.state.carline}
          isInteriorOnly={this.isInteriorOnly}
        />
      );
    }

    return (
      <div id="app">
        {loading.percentLoaded < 100 && (
          <Loadingbar percent={loading.percentLoaded} />
        )}
        {input}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/app.js